module.exports = __webpack_public_path__ + "img/nap_thumb_1.e327057d.jpg";